import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import './registerServiceWorker'
import MainToolbar from '@/components/MainToolbar'
import vuetify from '@/lib/vuetify'
import '@fortawesome/fontawesome-free/css/all.css'
import { mapGetters } from 'vuex'
import unitName from '@/lib/unitName'
import '@/assets/styles.scss'

Vue.config.productionTip = false

Vue.mixin({
  components: {
    MainToolbar
  },
  computed: {
    appSmall () {
      return this.$vuetify.breakpoint.smAndDown
    },
    ...mapGetters(['readOnly', 'userRole'])
  },
  methods: {
    skinProp (key) {
      return this.$store.getters.skinProp(key)
    },
    unitName (key) {
      return unitName(key)
    }
  }
})

router.onReady(() => {
  store.dispatch('rootBootstrap')
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  async created () {
    if (window.location.search && /skin=0/i.test(window.location.search)) {
      window.localStorage.setItem('skin', '')
    } else if ((window.location.search && /skin=sigma/i.test(window.location.search))) {
      window.localStorage.setItem('skin', 'sigma')
    }
    Object.entries(this.skinProp('colors'))
      .filter(([key, value]) => ['primary', 'secondary', 'default', 'accent', 'error'].includes(key))
      .forEach(([key, value]) => {
        this.$vuetify.theme.themes.light[key] = value
        this.$vuetify.theme.themes.dark[key] = value
      })
    document.title = this.skinProp('name') + ' Portal'
  }
}).$mount('#app')
